import * as React from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'
import FocusTrap from 'focus-trap-react'

interface Props {
  placeholder: string
  valueLabel: string
  isOpen?: boolean
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  refInput: React.Ref<HTMLInputElement>
  clearSearch: () => void
}

const SearchInput: React.FC<Props> = ({
  placeholder,
  onSearch,
  search,
  isOpen = false,
  valueLabel,
  refInput,
  clearSearch,
}) => {
  const showClearButton = (!!search && isOpen) || (!!valueLabel && !isOpen)

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'Space') {
      event.preventDefault()
      ;(event.target as HTMLInputElement).value += ' '
      onSearch(event as unknown as React.ChangeEvent<HTMLInputElement>)
    }
  }

  return (
    <Box flexDirection="row" height="s40" paddingY="s8" paddingX="s16" cursor="pointer">
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          allowOutsideClick: true,
        }}
      >
        <Box
          width="full"
          flexDirection="row"
          alignItems="center"
          gap="s4"
          overflowX="hidden"
          justifyContent="spaceBetween"
        >
          <input
            ref={refInput}
            disabled={!isOpen}
            type="text"
            onChange={onSearch}
            value={isOpen ? search : valueLabel}
            placeholder={placeholder}
            aria-label={placeholder}
            onKeyDown={onKeyDown}
            style={{
              width: '100%',
              fontWeight: 400,
              color: '#1E1E31',
              overflow: 'hidden',
              fontSize: '16px',
              pointerEvents: 'none',
            }}
          />
          {showClearButton && (
            <Box onClick={clearSearch}>
              <Icon.Medium icon="cross-circle" />
            </Box>
          )}
        </Box>
      </FocusTrap>
      <Box flexDirection="column" justifyContent="center" alignItems="center">
        {isOpen ? <Icon.Small icon="caret-up" /> : <Icon.Small icon="caret-down" />}
      </Box>
    </Box>
  )
}

export default SearchInput
